import React from 'react';
import { useLocation, Navigate, Link } from 'react-router-dom';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { AuthProvider, useAuth } from '@medical/shared/contexts/AuthContext';
import AdminProtectedRoute from './admin/auth/AdminProtectedRoute';
import FrontDeskProtectedRoute from './front-desk/auth/FrontDeskProtectedRoute';
import LoadingSpinner from '@medical/shared/components/LoadingSpinner';
import TTSPlayer from '@medical/shared/components/TTSPlayer';
import { AdminPortalApp, FrontDeskPortalApp } from './portal';

const AppContainer = styled.div`
  min-height: 100vh;
  background-color: #f8fafc;
`;

const HomeScreen = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  padding: 2rem;
  background: #0B63C5;
  color: white;
  text-align: center;
`;

const HomeTitle = styled.h1`
  margin: 0;
  font-size: 2rem;
`;

const HomeLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
`;

const HomeLink = styled(Link)`
  background: white;
  color: #4c1d95;
  text-decoration: none;
  font-weight: 600;
  padding: 0.85rem 1.5rem;
  border-radius: 10px;
  min-width: 160px;
`;

const AppRouter = () => {
  const location = useLocation();
  const { loading } = useAuth();
  const { i18n } = useTranslation();

  const isAdminRoute = location.pathname.startsWith('/admin');
  const isFrontDeskRoute = location.pathname.startsWith('/front-desk');

  React.useEffect(() => {
    if (i18n.language !== 'en') {
      i18n.changeLanguage('en');
    }
  }, [i18n]);

  if (loading) {
    return <LoadingSpinner />;
  }

  if (isAdminRoute) {
    return (
      <AppContainer>
        <AdminProtectedRoute>
          <AdminPortalApp />
        </AdminProtectedRoute>
      </AppContainer>
    );
  }

  if (isFrontDeskRoute) {
    return (
      <AppContainer>
        <FrontDeskProtectedRoute>
          <FrontDeskPortalApp />
        </FrontDeskProtectedRoute>
      </AppContainer>
    );
  }

  return (
    <HomeScreen>
      <HomeTitle>Medical Pain Tracker Portal</HomeTitle>
      <p>Choose a workspace</p>
      <HomeLinks>
        <HomeLink to="/admin">Admin</HomeLink>
        <HomeLink to="/front-desk">Front Desk</HomeLink>      </HomeLinks>
    </HomeScreen>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppRouter />
      <TTSPlayer />
    </AuthProvider>
  );
}

export default App;
